import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';


const Deposit = ({
    loading,
    walletAddress,
    handleCloseModal
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                setCopied(true);
                // Hide after 4 seconds
                setTimeout(() => setCopied(false), 4000);
            })
            .catch(err => console.error('Failed to copy:', err));
    };

    return (
        <>
            <div className="overlaid" onClick={() => handleCloseModal('deposit')}></div>
            <div className="USDT-deposit">
                <h2>Deposit Crypto to Start</h2>

                {copied && <div className="copied-notification">Copied!</div>}

                {loading ? (
                    <p>Loading wallet addresses...</p>
                ) : walletAddress ? (
                    <div className="crypto-addresses">

                        {/* Bitcoin */}
                        <div className="crypto-address-box">
                            <div className="qr-code-container">
                                <QRCodeSVG
                                    value={walletAddress.bitcoin.online}
                                    size={80}
                                    level="H"
                                />
                            </div>
                            <div className="address-info">
                                <h3>Bitcoin (BTC)</h3>
                                <div className="address-container">
                                    <p className="address">{walletAddress.bitcoin.online}</p>
                                    <button
                                        className="copy-button"
                                        onClick={() => handleCopy(walletAddress.bitcoin.online)}
                                    >
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Ethereum */}
                        <div className="crypto-address-box">
                            <div className="qr-code-container">
                                <QRCodeSVG
                                    value={walletAddress.ethereum.online}
                                    size={80}
                                    level="H"
                                />
                            </div>
                            <div className="address-info">
                                <h3>Ethereum (ETH)</h3>
                                <div className="address-container">
                                    <p className="address">{walletAddress.ethereum.online}</p>
                                    <button
                                        className="copy-button"
                                        onClick={() => handleCopy(walletAddress.ethereum.online)}
                                    >
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* USDT */}
                        <div className="crypto-address-box">
                            <div className="qr-code-container">
                                <QRCodeSVG
                                    value={walletAddress.usdt.online}
                                    size={80}
                                    level="H"
                                />
                            </div>
                            <div className="address-info">
                                <h3>USDT (TRC20)</h3>
                                <div className="address-container">
                                    <p className="address">{walletAddress.usdt.online}</p>
                                    <button
                                        className="copy-button"
                                        onClick={() => handleCopy(walletAddress.usdt.online)}
                                    >
                                        <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <p>Unable to fetch wallet addresses. Please contact support.</p>
                )}

                <span
                    className="close"
                    onClick={() => handleCloseModal('deposit')}
                >
                    &times; Close
                </span>
            </div>
        </>
    );
};

export default Deposit;